export default function Footer() {
  return (
    <footer className="border-t border-gray-800 bg-[#171717] py-8 text-sm text-gray-400">
      <div className="mx-auto flex w-full max-w-7xl justify-center px-6">
        <p className="leading-relaxed text-center">
          © {new Date().getFullYear()}{" "}
          <span className="font-bold text-indigo-400">AetherCV AI</span>. All rights reserved.{" "}
          Designed and developed by{" "}
          <a
            href="https://www.pshrinnovex.com"
            className="font-bold text-amber-400 hover:text-amber-300"
          >
            PSHR INNOVEX Pvt Ltd
          </a>
          .
        </p>
      </div>
    </footer>
  );
}
